import { UNIFIED_EVENT } from '../../filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { useLogicGroupRefinement } from '../../hooks/useLogicGroupRefinement';
import EditorConditionValueInput from './EditorConditionValueInput';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import UISelect from 'UIComponents/input/UISelect';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'UICo... Remove this comment to see the full error message
import UITypeaheadResultsItem from 'UIComponents/typeahead/results/UITypeaheadResultsItem';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorUnifiedEventRefinement = ({
  field,
  onRefinementChange,
  refinement
}) => {
  const {
    isChecked,
    onCheckboxChange,
    onRefinementConditionValueChange,
    onSelectedOptionChange,
    operatorName,
    operatorOptions,
    refinementCondition
  } = useLogicGroupRefinement(field, UNIFIED_EVENT, onRefinementChange, refinement);
  return /*#__PURE__*/_jsxs(View, {
    marginBlockStart: "300",
    as: "div",
    children: [/*#__PURE__*/_jsx(Checkbox, {
      checked: isChecked,
      onChange: onCheckboxChange,
      children: field.label
    }), /*#__PURE__*/_jsxs(View, {
      marginInlineStart: "600",
      marginBlockStart: "200",
      as: "div",
      children: [/*#__PURE__*/_jsx(UISelect, {
        disabled: !isChecked,
        onSelectedOptionChange: onSelectedOptionChange,
        optionRenderer: option => /*#__PURE__*/_jsx(UITypeaheadResultsItem, {
          message: true,
          option: option
        }),
        options: operatorOptions,
        readOnly: operatorOptions.length === 1,
        value: operatorName
      }), /*#__PURE__*/_jsx(View, {
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(EditorConditionValueInput, {
          condition: refinementCondition,
          disabled: !isChecked,
          filterFamily: UNIFIED_EVENT,
          onChange: onRefinementConditionValueChange
        })
      })]
    })]
  });
};
export default EditorUnifiedEventRefinement;